import { isNaN } from 'lodash'

const APP_LOCALE = 'en-US'

export function getLocalizedNumber(value?: number | bigint, locale = APP_LOCALE): string {
   if (value == null || isNaN(value)) return ''
   return Intl.NumberFormat(locale).format(value)
}
